import WorkoutPlansImage from "../../../assets/images/workout-plan.png";
import ProgressImage from "../../../assets/images/log-progress.png";
import TrackResultImage from "../../../assets/images/track-result.png";

export const headerData = [{
    title: "Pick a Workout Plan",
    content: "New to Exercise? Do not know where to start? Workout Plans is for you!",
    image: WorkoutPlansImage,
    link: {
        text: "Start here",
        to: "/fitness/workout-plans"
    }
}, {
    title: "View Your Plan",
    content: "View and make changes to your workout plan!",
    image: ProgressImage,
    link: {
        text: "Start here",
        to: "/fitness/my-progress"
    }
}, {
    title: "Workout Journal",
    content: "Record your fitness activities today!",
    image: TrackResultImage,
    link: {
        text: "Start here",
        to: "/fitness/journal"
    }
}]